/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { getCacheData } from "../../services/CacheService";
import { saveObraSocialPlan } from "../../../project/services/ObraSocialPlanService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  idObraSocial: null,
  descripcion: "",
  descripcionOdoo: "",
  importe: 0,
  observaciones: "",
};

const itemGender = "M";
const nameItemText = "Plan de Obra Social";
//
// #####################################################################################################################
//
const ObraSocialPlanDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [valueACObrasSociales, setValueACObrasSociales] = useState({});
  const [inputValueACObrasSociales, setInputValueACObrasSociales] = useState("");
  const [obrasSociales, setObrasSociales] = useState([]);
  //
  // ################################################################################
  //
  useEffect(() => {
    loadObrasSociales();

    if (actionCrud === "new") {
      setValueACObrasSociales(obrasSociales[0]);
      setItemCrudLocal(initialState);
    } else {
      setValueACObrasSociales(itemCrud.obraSocial);
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {
      if (!inputValueACObrasSociales) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar una Obra Social",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.descripcion.trim() === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar una descripción del Plan",
        });
        setShowMessage(true);
        return;
      }

      if (!itemCrudLocal.descripcionOdoo || itemCrudLocal.descripcionOdoo.length > 5) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar el código Odoo de no más de 5 caracteres",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ################################################################################
  //
  const save = async () => {
    let _itemCrud = {
      id_obra_social: valueACObrasSociales.id || null,
      descripcion: itemCrudLocal.descripcion,
      descripcion_odoo: itemCrudLocal.descripcionOdoo,
      importe: +itemCrudLocal.importe,
      observaciones: itemCrudLocal.observaciones,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    setIsDoingSomething(true);
    const response = await saveObraSocialPlan(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  const loadObrasSociales = async () => {
    const response = await getCacheData("obra_social");
    if (response.ok) {
      let _response = response.data.data;
      let _obrasSociales = [];
      _response.forEach((item) => {
        _obrasSociales.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setObrasSociales(_obrasSociales);
    } else {
      setObrasSociales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <Typography variant="h5" display="block" gutterBottom>
            {actionCrud === "new"
              ? itemGender === "M"
                ? "Nuevo"
                : "Nueva"
              : actionCrud === "update"
                ? "Editando"
                : actionCrud === "enable"
                  ? "Habilitando"
                  : "Deshabilitando"}{" "}
            {nameItemText}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Autocomplete
                id="ObraSocial"
                sx={{ width: "100%" }}
                size="small"
                value={valueACObrasSociales ?? null}
                onChange={(event, newValue) => {
                  setValueACObrasSociales(newValue);
                }}
                inputValue={inputValueACObrasSociales}
                onInputChange={(event, newInputValue) => {
                  setInputValueACObrasSociales(newInputValue);
                }}
                options={obrasSociales}
                renderInput={(params) => <TextField {...params} label="Obra Social" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                getOptionLabel={(option) => option.label || ""}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                variant="outlined"
                size="small"
                name="descripcion"
                label="Descripción"
                value={itemCrudLocal.descripcion}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                sx={{ width: "100%" }}
                inputProps={{ maxLength: 80 }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                variant="outlined"
                size="small"
                name="importe"
                label="Importe"
                value={itemCrudLocal.importe}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                sx={{ width: "100%" }}
                inputProps={{ maxLength: 12 }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcionOdoo"
                label="Descripción para Odoo"
                variant="outlined"
                size="small"
                name="descripcionOdoo"
                value={itemCrudLocal.descripcionOdoo}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off",
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: "80px",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  onClick={handleSave}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog >

      < WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ObraSocialPlanDialog;
